import rrulePlugin from '@fullcalendar/rrule'

import { expandZonedRecurrence } from './zonedRecurrence'

// FullCalendar's adapter otherwise reinterprets rrule's browser-local results
// as calendar-local dates. Named zones must instead expand to actual instants.
export default {
  ...rrulePlugin,
  recurringTypes: rrulePlugin.recurringTypes.map((type) => ({
    ...type,
    parse(
      eventProps: Parameters<typeof type.parse>[0],
      dateEnv: Parameters<typeof type.parse>[1]
    ) {
      const parsed = type.parse(eventProps, dateEnv)
      return (
        parsed && {
          ...parsed,
          typeData: {
            ...parsed.typeData,
            appAllDay: eventProps.allDay ?? parsed.allDayGuess,
            appNamedZone:
              typeof eventProps.rrule === 'string'
                ? /DTSTART;TZID=/i.test(eventProps.rrule)
                : !!eventProps.rrule?.tzid
          }
        }
      )
    },
    expand(
      data: Parameters<typeof type.expand>[0] & {
        appAllDay?: boolean
        appNamedZone?: boolean
      },
      range: Parameters<typeof type.expand>[1],
      dateEnv: Parameters<typeof type.expand>[2]
    ) {
      const rule = data.rruleSet.toString()
      if (data.appAllDay || (!data.appNamedZone && !rule.includes('TZID='))) {
        return type.expand(
          data.appAllDay || data.dateEnv ? { ...data, dateEnv } : data,
          range,
          dateEnv
        )
      }
      const margin = 86400000
      return expandZonedRecurrence(
        rule,
        new Date(dateEnv.toDate(range.start).valueOf() - margin),
        new Date(dateEnv.toDate(range.end).valueOf() + margin)
      )
        .map((date) => dateEnv.createMarker(date))
        .filter((marker): marker is Date => marker !== null)
    }
  }))
}
